module.exports = dxConfigData;